import { Link, useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumb = ({ current }) => {
  const navigate = useNavigate();

  const goToPractice = () => {
    navigate("/");
    setTimeout(() => {
      const el = document.getElementById("practice-areas");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  return (
    <nav
      data-testid="breadcrumb"
      aria-label="Breadcrumb"
      className="flex items-center gap-2.5 font-sans text-[11px] tracking-[0.14em] uppercase"
    >
      <Link
        to="/"
        data-testid="breadcrumb-home"
        className="text-canvas/50 hover:text-gold transition-colors duration-300"
      >
        Home
      </Link>
      <ChevronRight className="w-3 h-3 text-canvas/30" strokeWidth={1.5} />
      <button
        onClick={goToPractice}
        data-testid="breadcrumb-practice-areas"
        className="text-canvas/50 hover:text-gold transition-colors duration-300"
      >
        Practice Areas
      </button>
      <ChevronRight className="w-3 h-3 text-canvas/30" strokeWidth={1.5} />
      <span data-testid="breadcrumb-current" className="text-canvas">
        {current}
      </span>
    </nav>
  );
};
